import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_REPORT, RECEIVE_REPORT, GET_USER_REPORTS } from '../constants/ActionTypes'

//= ===============================
// Fetch One Report Action
//= ===============================

const requestReport = (report_id) => {
	return {
		type: REQUEST_REPORT,
		report_id
	}
}

const receiveReport = (report_id, response) => {
	return {
		type: RECEIVE_REPORT,
		report_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchReport = (report_id) => {
	return dispatch => {
		dispatch(requestReport(report_id))
		let url = `${API_URL}/story/` + report_id
		axios.get(url)
		.then((response) => {
			dispatch(receiveReport(report_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

const shouldFetchReport = (state, report_id) => {
	const report = state.reportById[report_id]
	if (!report) {
		return true
	} else if (report.isFetching) {
		return false
	}
	return true
}

export const loadReport = (report_id) => (dispatch, getState) => {
	if (shouldFetchReport(getState(), report_id)) {
		return dispatch(fetchReport(report_id))
	}
}

/** USER REPORTS **/

const fetchUserReports = (response) => {
	return {
		type: GET_USER_REPORTS,
		payload: response.data
	}
}

export const loadUserReports = () => (dispatch, getState) => {
	let url = `${API_URL}/story/user`
	let token = getState().auth.token
	let authorization = "Bearer " + token
	axios.get(url, {headers:{'Authorization': authorization}})
	.then((response) => {
		dispatch(fetchUserReports(response))
	})
	.catch((error) => {
		console.log(error)	
	})
}

export const deleteReport = (report_id) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Authorization': authorization}}
	
	let url = `${API_URL}/story/remove/` + report_id
	axios.delete(url, headers)
	.then((response) => {
		dispatch(loadUserReports())
	})
	.catch((error) => {
		console.log(error)
	})
}


// WEBPACK FOOTER //
// ./src/actions/report.js